<template>
  <div
    class="exit-alert-container col-center bg-color-light-translucent z-[1000] rounded shadow px-3 py-2 fixed left-1/2 bottom-4 -translate-x-1/2"
  >
    <CustomImage class="app-logo mb-1 w-auto h-4" :src="DashboardLogo" />
    <div class="color-primary text-xxs">Press/swipe again to exit</div>
  </div>
</template>
<script lang="ts">
import CustomImage from "@/components/primitives/CustomImage.vue";
import { useAppSettingsStore } from "@/stores/core/appSettingsStore";
import { storeToRefs } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
  components: { CustomImage },
  name: "AppExitAlert",
  setup() {
    const appSettingsStore = useAppSettingsStore();
    const { DashboardLogo } = storeToRefs(appSettingsStore);
    return { DashboardLogo };
  },
});
</script>
